import {
  Box,
  Button,
  CircularProgress,
  Fade,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import KeyboardBackspaceRoundedIcon from "@mui/icons-material/KeyboardBackspaceRounded";
import { Url } from "../Api/Api";
import axios from "axios";
import ProfileOTPVarificationPage from "./ProfileOTPVarificationPage";

const ProfileForgotPassword = ({ isStudent, email }) => {
  const [otpVerification, setOtpVerification] = useState(false);
  const [otp, setOtp] = useState(Array(6).fill(""));
  const [timeLeft, setTimeLeft] = useState(60);
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [forgotPasswordOpen, setForgotPasswordOpen] = useState(false);

  const handleResendOTP = async () => {
    await setOtp(Array(6).fill(""));
    setTimeLeft(60);
    setErrorMessage("");
  };

  const UserUrl = isStudent ? Url.StudentForgetPassword : Url.ForgetPassword;

  const handleSubmit = async () => {
    const input = {
      ...(isStudent
        ? { studentEmail: String(email) }
        : { emailId: String(email) }),
    };
    try {
      setIsLoading(true);
      const response = await axios.post(UserUrl, input);

      if (response?.data?.status === "1") {
        setOtpVerification(true);
        setForgotPasswordOpen(true);
      } else {
        setErrorMessage(
          response?.data?.message || "Failed to send OTP. Please try again."
        );
      }
    } catch (error) {
      setErrorMessage("Network error. Please try again later.");
    } finally {
      handleResendOTP();
      setIsLoading(false);
    }
  };

  const validateEmail = (email) => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!email) return "Please enter an email address.";
    if (!emailRegex.test(email)) return "Please enter a correct email address.";
    return null;
  };

  return (
    <>
      {otpVerification && forgotPasswordOpen ? (
        <ProfileOTPVarificationPage
          handleResendOTP={handleResendOTP}
          handleSubmit={handleSubmit}
          email={email}
          timeLeft={timeLeft}
          setTimeLeft={setTimeLeft}
          otp={otp}
          setOtp={setOtp}
          setForgotPasswordOpen={setForgotPasswordOpen}
          isStudent={isStudent}
        />
      ) : (
        <Fade in={true} timeout={800}>
          <Button
            disabled={isLoading}
            onClick={handleSubmit}
            fullWidth
            variant="contained"
            sx={{
              minWidth: 120,
              textTransform: "none",
              background: "#51B0CF",
              ":hover": { backgroundColor: "#51B0CF", color: "white" },
              borderRadius: 2,
              cursor: "pointer",
            }}
          >
            {isLoading ? (
              <CircularProgress
                enableTrackSlot
                size="30px"
                sx={{ color: "white" }}
              />
            ) : (
              "Change Password"
            )}
          </Button>
        </Fade>
      )}
    </>
  );
};

export default ProfileForgotPassword;
